const R = require('ramda')
const SCI = require('sci')
const Promise = require('bluebird')
const agent = require('superagent')
const $ = require('jquery')
const { url, matrixUrl } = require('../utils')

const $queuedLoading = $('.global-queued-loading')

class Client {
    constructor () {
        this.isBlocked = false
        this.$blockedContainer = null
        this.el = null
        this.files = {}
        this.formData = null
        this.onProgressFn = null
    }

    block ($container) {
        this.$blockedContainer = $($container)

        this.$blockedContainer
            .removeClass('blockable')
            .addClass('blockable')
            .addClass('blocked')
        this.isBlocked = true

        return this
    }

    onProgress (fn) {
        this.onProgressFn = fn
        return this
    }

    showMessage (message) {
        if (!message) return

        const $queue = $('#loading-queue')
        const $spinner = $queue.find('> .queue-spinner')

        this.el = $queuedLoading
            .clone()

        if (!$spinner.hasClass('is-loading')) {
            $spinner.addClass('is-loading')
        }

        $queue.find('> .queue')
            .append(this.el)

        this.el
            .find('.message')
            .html(message || 'Carregando...')

        this.el.css('display', 'block')
    }

    hideMessage () {
        if (this.isBlocked) {
            this.$blockedContainer.removeClass('blocked')
        }

        if (this.el) {
            this.el.remove()

            if ($('#loading-queue > .queue > *').length < 1) {
                $('#loading-queue > .queue-spinner').removeClass('is-loading')
            }
        }
    }

    execute (message, instance) {
        this.showMessage(message)

        return new Promise((resolve, reject) => {
            const startedWhen = new Date().getTime()
            let speedSamples = []
            let downloaded = 0
            let lastProgress = new Date().getTime()

            const token = SCI.get('token')

            instance.set('Accept', 'application/json')
            instance.set('Authorization', `Bearer ${token}`)
            instance.set('X-Timezone', new Date().getTimezoneOffset() / 60)

            instance
                .on('progress', (event) => {
                    if (this.onProgressFn && event.direction === 'upload') {
                        const diffSinceLastProgress = new Date().getTime() - lastProgress

                        lastProgress = new Date().getTime()

                        const now = new Date().getTime()
                        const timeDiff = now - startedWhen

                        const timeDiffSeconds = timeDiff / 1000

                        const downloadedNow = event.loaded - downloaded
                        downloaded = event.loaded

                        speedSamples = R.takeLast(9, speedSamples).concat([{ size: downloadedNow, time: diffSinceLastProgress }])

                        const wastedTime = R.pipe(R.map(_ => _.time), R.sum)(speedSamples)
                        const downloadedSize = R.pipe(R.map(_ => _.size), R.sum)(speedSamples)

                        const downloadSpeed = Math.ceil(downloadedSize / (wastedTime / 1000))

                        const remainingBytes = event.total - event.loaded

                        const remainingTime = Math.ceil(remainingBytes / downloadSpeed)

                        this.onProgressFn(event.percent, event.loaded, event.total, remainingBytes, downloadSpeed, remainingTime, timeDiffSeconds)
                    }
                })
                .end((err, response) => {
                    // esse timeout serve para eyecandy da tela de loading
                    this.hideMessage()

                    if (err) {
                        err.hiddenError = true

                        if (!err.response) {
                            return reject(err)
                        }

                        const json = err.response.body
                        const sessionData = window.SESSION_DATA || null

                        if (!IS_DEV && sessionData !== null && json.user === null) {
                            for (const error of json.errors) {
                                if (error.code === 25) {
                                    location.href = url('/logout?from=trial-expired')
                                    return
                                }
                            }

                            location.href = url('/error/expired')
                            return
                        } else if (IS_DEV && sessionData !== null && json.user === null) {
                            console.error('[DEV] Sessão possivelmente expirou')
                        }

                        return resolve(json)
                    }

                    return resolve(response.body)
                })
        })
    }

    secureMessage (message) {
        this.secureModalMessage = message

        return this
    }

    secureButton (message) {
        this.secureModalButton = message

        return this
    }

    get (message, path, params, config = {}) {
        return this.execute(message, agent.get(matrixUrl(path)).query(params))
    }

    post (message, path, data, config = {}) {
        return this.execute(message, agent.post(matrixUrl(path)).send(data))
    }

    put (message, path, data, config = {}) {
        return this.execute(message, agent.put(matrixUrl(path)).send(data))
    }

    delete (message, path, data, config = {}) {
        return this.execute(message, agent.del(matrixUrl(path)).send(data))
    }

    attach (key, file) {
        this.files[key] = file
        return this
    }
}

Client.get = (message, path, params) => {
    return new Client()
        .get(message, path, params)
}

Client.post = (message, path, data, config) => {
    return new Client()
        .post(message, path, data, config)
}

Client.put = (message, path, data) => {
    return new Client()
        .put(message, path, data)
}

Client.delete = (message, path, data) => {
    return new Client()
        .delete(message, path, data)
}

Client.block = (value) => {
    return new Client()
        .block(value)
}

Client.onProgress = (fn) => {
    return new Client()
        .onProgress(fn)
}

module.exports = Client



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/matrix-client.js